import {Component, computed, input, signal, ChangeDetectionStrategy} from "@angular/core"
import {ListItemComponent} from "@common/components/item/list-item/list-item.component"
import {getNodeIconClass, getNodeIconSecondaryClass, isTemplateValueNodeClass} from "@app/template-editor/helpers/template-icons"
import {getTemplateNodeClassLabel} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-template-menu-item",
    templateUrl: "./template-menu-item.component.html",
    styleUrls: ["./template-menu-item.component.scss", "./../../helpers/template-icons.scss"],
    imports: [ListItemComponent],
})
export class TemplateMenuItemComponent {
    readonly $nodeClass = input.required<string>({alias: "nodeClass"})
    readonly $isNodeValue = computed(() => isTemplateValueNodeClass(this.$nodeClass()))
    readonly $selected = input<boolean>(undefined, {alias: "selected"})
    readonly $disabled = input<boolean>(undefined, {alias: "disabled"})
    readonly $label = input<string>(undefined, {alias: "label"})
    readonly $displayLabel = computed(() => {
        const label = this.$label()
        if (label) return label
        return getTemplateNodeClassLabel(this.$nodeClass())
    })
    readonly $getNodeIconClass = signal(getNodeIconClass)
    readonly $getNodeIconSecondaryClass = signal(getNodeIconSecondaryClass)
}
